<template>
    <PageView>
        <a-spin :spinning="loading">
            <a-card :title="`${id ? '编辑' : '添加'}轮播`">
               
                <a-form :form="form" style="width: 350px">
                    <a-form-item label="名称" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-input
                            v-decorator="[`name`, { rules: [{ required: true, message: '请输入名称' }] }]"
                            placeholder="请输入名称"
                        />
                    </a-form-item>
                    <a-form-item label="简介" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-input
                            v-decorator="[`title`, { rules: [{ required: true, message: '请输入简介' }] }]"
                            placeholder="请输入简介"
                        />
                    </a-form-item>
                    <a-form-item label="排序号" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-input
                            v-decorator="[`sort`, { rules: [{ required: true, message: '请输入排序' }] }]"
                            placeholder="请输入排序"
                        />
                    </a-form-item>
                    <a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <span> <span style="color:red">*</span> 图片:</span>
                        <a-row :gutter="10" class="inputGroup" style="margin-bottom: 20px" type="flex"
                            justify="space-around" align="middle">
                            <a-col :xs="12" :md="8" :lg="8" :xl="10">
                                <div class="imgContaienr">
                                    <div class="con">
                                        <img v-if="pic !== ``" :src="pic" />
                                        <a v-else class="placeText">请选择图片</a>
                                    </div>
                                </div>
                            </a-col>
                            <a-col :xs="24" :md="8" :lg="8" :xl="14">
                                <div class="btnCon">
                                    <input @change="handleChange($event, 2)" type="file" accept="image/*" />
                                    <a-button-group>
                                        <a-button type="primary">选择图片</a-button>
                                    </a-button-group>
                                </div>
                            </a-col>
                        </a-row>
                    </a-form-item>
                </a-form>
                <a-button type="primary" @click="sub">
                    提交
                </a-button>
                <a-button type="primary" @click="$router.back()" style="margin-left:10px">
                    返回
                </a-button>
            </a-card>
        </a-spin>
    </PageView>
</template>

<script>
import GoodsCats from '../../api/GoodsCats.js'
import Home from '../../api/Home.js'
export default {
    name: 'GoodsCatsEdit',
    data() {
        return {
            form: this.$form.createForm(this),
            loading: this.$route.query.id ? true : false,
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 18 }
            },
            pic: '',
            status: undefined,
            id: this.$route.query.id || undefined
        }
    },
    mounted() {
        if (this.id) this.getOne()
    },
    methods: {
        getOne() {
            this.$nextTick(() => {
                let data = this.$route.query.data
                this.pic = data.img
                this.form.setFieldsValue({
                    sort: data.sort,
                    name: data.name,
                    title: data.title
                })
                this.loading = false
            })
        },
        handleChange(e) {
            let file = e.target.files[0]
            let reader = new FileReader()
            reader.onload = () => {
                Home.upload({ img: reader.result }).then(res => {
                    this.pic = res.result
                })
                reader.onload = null
            }
            reader.readAsDataURL(file)
        },
        sub() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.loading = true
                    if (this.id) {
                        GoodsCats.SaveGoodsCats({ ...values, id: this.id, img: this.pic })
                            .then(res => {
                                this.loading = false
                                this.$router.back()
                            })
                            .catch(res => {
                                this.loading = false
                            })
                    } else {
                        GoodsCats.AddGoodsCats({ ...values, img: this.pic })
                            .then(res => {
                                this.loading = false
                                this.$router.back()
                            })
                            .catch(res => {
                                this.loading = false
                            })
                    }
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
.imgContaienr {
    width: 300px;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 15px;

    .con {
        height: 300px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            display: block;
            max-height: 100%;
            max-width: 100%;
        }

        .placeText {
            font-size: 20px;
        }
    }
}

.btnCon {
    margin-left: 210px;
    position: relative;
    overflow: hidden;
    display: inline-block;

    input {
        display: block;
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        background: red;
        opacity: 0;
    }
}
</style>
